import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {getDirection, pexios} from "../../../utils/functions";
import {history} from "../../../utils/variables";
import {setRouterData} from "../../../redux/actions";
import Modal from "../../master/Modal";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
//import TimerCounter from "../../master/TimerCounter";
// import FlipCountdown from '@rumess/react-flip-countdown';
import { useTranslation } from "react-i18next";

export default function Notifications() {
    const { t, i18n } = useTranslation();
    // const [dayCounter ,setDayCounter] = useState(false);
    // const today = new Date();
    // const deadLine = new Date('july 23, 2023 00:00:00');
    // const distance = deadLine.getTime()-today.getTime();
    //const [isTimeUp, setIsTimeUp] = useState(deadLine.getTime()-today.getTime() >0 ? false : true);
    const [notifications, setNotifications] = useState([]);
    const [isModalShown, setIsModalShown] = useState(false);

    const { location ,user } = useSelector(store => store);
    const [ruleModal , setRuleModal] = useState(false);
    const [gpsModal,setGpsModal] = useState(false)
    const dispatch = useDispatch();

    useEffect(() => {
        pexios('api/my_active_case')
            .then(res => {
                setNotifications(res?.data?.data || []);
            });
    }, []);

    function handleDetails({type, status = null, accidentId = null}) {
        switch (type) {
            case 'unfinishedAccident':
                // pexios('/api/request_new_accident', 'post', location)
                //     .then(res => {
                //         dispatch(setRouterData({id: accidentId, type: 'accident'}));
                //         history.push('/waiting');
                //     });
                dispatch(setRouterData({id: accidentId, type: 'accident'}));
                history.push('/waiting');
                return;
            case 'onProgressAccident':
                window.open('tel:02191065151');
                return;
            case 'unfinishedReports':
                history.push(`/report-list?status=${status}`);
                return;
            case 'AccidentQueue':
                //pexios('/api/change_expert_online', 'post', { online: 1 })
                    // .then(() => {
                    //     history.push('/expert-waiting');
                    // });
                    history.push('/expert-waiting');
                return;
            default: return;
        }
    }
    ///
    function preRulesChecking (){
        if(user.type === 'expert'){
            if(!user.check_privacy) {
            setRuleModal(true)
            }else{
        if(user.id !== 89957) {
            if(navigator.permissions) {
                navigator.permissions.query({name : "geolocation"})
                .then((result)=>{
                    if(result.state === "denied"){
                        setGpsModal(true)
                    }else {
                        setIsModalShown(true)
                    }
                })
            }else{
                navigator.geolocation.watchPosition((info)=>{
                    setIsModalShown(true)
                  },()=>{
                    setGpsModal(true)
                  })
            }
        }else{
            setIsModalShown(true)
        }
        }}
        else {
            setIsModalShown(true)
        }
    }

    return (
        <>
            {
                notifications.length ?
                    <div className='p20'>
                        <button
                            className='btn btn-blue btn-block btn-circle'
                            // onClick={() => setIsModalShown(true)}
                            onClick={preRulesChecking}
                        >
                            {t('Follow up on my files')}
                        </button>
                    </div> :
                    null
            }
            <div className='notification-modal'>
                <Modal visible={ruleModal}>
                <div className="modal-content text-justify pb20 pr20 pl20">
                <i className='fas fa-times pt10' onClick={() => setRuleModal(false)} />
                    <div style={{ maxWidth: 500 }}>
                    <p className='pb10 pr10'>
                        {t('GpsModal title',{name: user.full_name})}
                    </p>
                    <p className='buttonModal-text p10'>
                        {t('RuleModal we need your acceptance')}
                    </p>
                    </div>
                    <Link
                    to="/rules"
                    className="btn btn-block mt20 btn-blue btn-circle"
                    >
                    {t('Terms and rules')}
                    </Link>
                </div>
                </Modal>
                <Modal visible={gpsModal}>
                    <div className="modal-content text-justify p20" style={{overflowY : 'auto'}}>
                        <div style={{ maxWidth: 500 }}>
                        <p className='pb10 pr10'>
                        {t('GpsModal title',{name: user.full_name})}
                        </p>
                        <p className='gpsModal-text p10'>
                            {t('GpsModal message')}
                        </p>
                        </div>
                        <a 
                        className="btn btn-block mt20 btn-blue btn-circle" 
                        href={`https://www.hamrahac.com/education/${user.id}/${user.mobile}`} target="_blank" style={{color :'white'}}> 
                       {t('GpsModal btn how to turn on')} 
                        </a>
                        <button
                        onClick={() => setGpsModal(false)}
                        className="btn btn-block mt20 btn-blue btn-circle"
                        >
                            {t('GpsModal btn i know how to turn on')}
                        </button>
                    </div>
                </Modal>
                {/* <Modal visible={dayCounter}>
                    <div className="modal-content text-justify p20" style={{overflowY : 'auto'}}>
                        <div style={{ maxWidth: 500 }}>
                        <b className="d-flex mt10 mb10 " style={{justifyContent : 'left', fontSize: '25px', color: '#a30505'}}>
                            <FlipCountdown
                                size='large'
                                hideYear
                                hideMonth
                                endAtZero
                                endAt={'2023-7-23 00:00:00'}
                                //onTimeUp={()=>setTimeout(()=>setDayCounter(false),3000)}
                            />
                        </b>
                        <p className='pb10 pr10'>
                        {`کارشناس محترم ${user.full_name} عزیز`}
                        </p>
                        <p className='gpsModal-text p10'>
                            {`سیستم همراه بیمه خلیج فارس `}
                            <strong style={{color : '#5ec3e1'}}>"پولت"</strong>
                            {` داره رشد میکنه و به زودی فقط به دستگاه هایی که اطلاعات موقعیت مکانی شون رو داشته باشه، اجازه فعالیت میده`}
                        </p>
                        </div>
                        <a 
                        className="btn btn-block mt20 btn-blue btn-circle" 
                        href={`https://www.hamrahac.com/education/${user.id}/${user.mobile}#gps`} target="_blank" style={{color :'white'}}> 
                        چجوری روشن کنم؟ 
                        </a>
                        <button
                        onClick={() => {
                            setDayCounter(false)
                            setIsModalShown(true)
                        }}
                        className="btn btn-block mt10 btn-green btn-circle"
                        >
                            بلدم، روشن میکنم
                        </button>
                    </div>
                </Modal> */}
                <Modal visible={isModalShown}>               
                    <div className='modal-content' style={{overflowY: 'auto'}}>
                    <div className={`close-modal ${getDirection(i18n.language) === 'leftToRight' && 'flex-row-reverse'}`}>
                        <i className='fas fa-times' onClick={() => setIsModalShown(false)} />
                        <span className="modal-title">{t('My notifications')}</span>
                    </div>
                        <ul>
                            {
                                notifications.map((itm, index) => (
                                    <li key={index} className={`d-flex align-items-center space-between ${getDirection(i18n.language) === 'leftToRight' && 'flex-row-reverse'}`}>
                                        <span>{itm.message}</span>
                                        <button className='btn btn-blue btn-sm m5' onClick={() => handleDetails(itm)}>{itm.btn}</button>
                                    </li>
                                ))
                            }
                        </ul>
                    </div>
                </Modal>
            </div>
        </>
    );
}
